import { type Ref, ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'

const useSpeakToExpertModalStore = defineStore('SpeakToExpert', () => {
    const isOpen = ref(false)

    const close = () => {
        isOpen.value = false
    }
    const open = () => {
        isOpen.value = true
    }

    return {
        isOpen,
        close,
        open,
    }
})

export interface SpeakToExpertModalConfig {
    isOpen: Ref<boolean>
    close(): void
    open(): void
    runAndClose(fn: (...args: any) => any): void
}

export function useSpeakToExpertModalConfig(): SpeakToExpertModalConfig {
    const speakToExpertStore = useSpeakToExpertModalStore()
    const { isOpen } = storeToRefs(speakToExpertStore)
    const { open, close } = speakToExpertStore

    const runAndClose = (fn: (...args: any) => any) => {
        fn()
        close()
    }

    return {
        isOpen,
        close,
        open,
        runAndClose,
    }
}
